var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    strokeWidth: "0px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.7012 5.00049C29.7012 5.00049 29.4082 2.93213 28.5059 2.02393C27.3633 0.828613 26.0859 0.822754 25.5 0.752441C21.3047 0.447754 15.0059 0.447754 15.0059 0.447754H14.9941C14.9941 0.447754 8.69531 0.447754 4.5 0.752441C3.91406 0.822754 2.63672 0.828613 1.49414 2.02393C0.591797 2.93213 0.304688 5.00049 0.304688 5.00049C0.304688 5.00049 0 7.43213 0 9.85791V12.1313C0 14.5571 0.298828 16.9888 0.298828 16.9888C0.298828 16.9888 0.591797 19.0571 1.48828 19.9653C2.63086 21.1606 4.13086 21.1196 4.79883 21.2485C7.20117 21.4771 15 21.5474 15 21.5474C15 21.5474 21.3047 21.5356 25.5 21.2368C26.0859 21.1665 27.3633 21.1606 28.5059 19.9653C29.4082 19.0571 29.7012 16.9888 29.7012 16.9888C29.7012 16.9888 30 14.563 30 12.1313V9.85791C30 7.43213 29.7012 5.00049 29.7012 5.00049ZM11.9004 14.8911V6.45947L20.0039 10.6899L11.9004 14.8911Z",
    fill: "white",
    fillOpacity: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.5940d4ae.svg";
export { ForwardRef as ReactComponent };